<template>
    <LayoutBase :has-fixed-group="hasFixedGroup" :nav="nav">
        <slot name="breadcrumbs"></slot>
        <slot name="alt-header"></slot>
        <header id="content__header">
            <slot name="header"></slot>
        </header>
        <div class="toolbar">
            <fieldset class="toolbar__filters">
                <div class="flex-fix">
                    <slot name="filters"></slot>
                </div>
            </fieldset>

            <fieldset class="toolbar__search">
                <div class="flex-fix">
                    <slot name="search"></slot>
                </div>
            </fieldset>
        </div>

        <slot></slot>
    </LayoutBase>
</template>

<script>
import LayoutBase from './LayoutBase';

export default {
    components: {
        LayoutBase,
    },
    props: {
        nav: {
            type: Boolean,
            default: true,
        },
        hasFixedGroup: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss">
@import '~reflex-grid/scss/includes/variables';
@import '~reflex-grid/scss/includes/mixins';
@import '~@/theme/_variables.scss';
@import '~@/mixins/_class.scss';
@import '~@/theme/_extenables.scss';

#content__header {
    &:empty {
        display: none !important;
    }

    .btn--primary {
        width: 23rem;

        @include respond-to(medium) {
            width: auto;
        }
    }
}
</style>
